<script>
  import {tick, afterUpdate, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import SplitText from 'gsap/SplitText'

  export let size = 1
  export let style = 'fly'
  export let delay = 0
  export let triggerStart = 'top 70%'
  export let speed = 1

  let clientWidth, title, titleEl, tl, st, lastWidth = 0, rendering = false, rendered = false, timeout;

  $: className = 'title' + ($$props.class ? ' ' + $$props.class : '')

  // $: if(clientWidth > 0) {
  //   if(title) {
  //     title.revert()
  //     tl.kill()
  //   }
  //   //render()
  // }

  afterUpdate(() => {
    if(lastWidth != clientWidth && !rendering) {
      rendering = true
      rendered = false
      title?.revert()
      window.requestAnimationFrame(render)
    }
    lastWidth = clientWidth
  })

  function render () {
    tl = gsap.timeline()
    const fromY = size === 1 ? 40 : 20
    switch(style) {
      case 'maskup' :
        title = new SplitText(titleEl, {type: 'words,lines', wordsClass: 'word', linesClass: 'line'})
        title.lines.forEach(line => {
          line.style.overflow = 'hidden'
        })
        title.words.forEach((word, index) => {
          tl.set(word, {opacity: 0, y: fromY}, 0)
          tl.fromTo(word,
            {opacity: 0, y: fromY},
            {
              opacity: 1,
              y: 0,
              ease: 'power2.out',
              duration: 0.6,
            }, delay + .01 + index * (.05 / speed))
        })
        break;
      default :
        title = new SplitText(titleEl, {type: 'lines', linesClass: 'line'})
        title.lines.forEach((line, index) => {
          tl.set(line, {opacity: 0, y: fromY}, 0)
          tl.fromTo(line,
            {opacity: 0, y: fromY},
            {
              opacity: 1,
              y: 0,
              ease: 'power2.out',
              duration: 0.8,
            }, delay + .01 + index * (.15 / speed))
        })
    }
    st = ScrollTrigger.create({
      trigger: titleEl,
      start: triggerStart,
      toggleActions: 'play play play pause',
      animation: tl
    })
    rendered = true
    setTimeout(() => {
      rendering = false
    }, 100)
  }

  onDestroy(() => {
    st?.kill()
    tl?.kill()
  })
</script>
<div class="anim-title" class:hide={!rendered} bind:clientWidth={clientWidth}>
{#if size === 1}
  <h1 class={className} class:maskup={style === 'maskup'} bind:this={titleEl}>
    <slot></slot>
  </h1>
{:else if size === 2}
  <h2 class={className} class:maskup={style === 'maskup'} bind:this={titleEl}>
    <slot></slot>
  </h2>
{:else if size === 3}
  <h3 class={className} class:maskup={style === 'maskup'} bind:this={titleEl}>
    <slot></slot>
  </h3>
{:else if size === 4}
  <h4 class={className} class:maskup={style === 'maskup'} bind:this={titleEl}>
    <slot></slot>
  </h4>
{:else if size === 0}
  <p class={className} class:maskup={style === 'maskup'} bind:this={titleEl}>
    <slot></slot>
  </p>
{/if}
</div>
<style>
  .maskup :global(.line) {
    line-height: 1.3;
  }
  h1.maskup :global(.line + .line) {
    margin-top: -0.3em;
  }
  h2.maskup :global(.line + .line) {
    margin-top: -0.25em;
  }
  h3.maskup :global(.line + .line) {
    margin-top: -0.2em;
  }
  h4.maskup :global(.line + .line) {
    margin-top: -0.2em;
  }
  p.maskup :global(.line + .line) {
    margin-top: -0.2em;
  }
  .anim-title.hide {
    opacity: 0
  }
</style>